export default ({ request }) => ({
  fabricCardListApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/card/list',
      method: 'post',
      data,
    })
  },
  fabricCardSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/card/save',
      method: 'post',
      data,
    })
  },
  fabricCardDelApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/card/del',
      method: 'post',
      data,
    })
  },
  fabricCardchangeLocationApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/card/changeLocation',
      method: 'post',
      data,
    })
  },
  fabricCardDetailBarcodeApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/card/detail/fabricCardBarcode',
      method: 'post',
      data,
    })
  },
  fabricCardExportCheckApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/card/export/check',
      method: 'post',
      data,
    })
  },
})
